import { render } from "./StarfieldDebug.vue?vue&type=template&id=632ece19&scoped=true"
import script from "./StarfieldDebug.vue?vue&type=script&lang=js"
export * from "./StarfieldDebug.vue?vue&type=script&lang=js"

import "./StarfieldDebug.vue?vue&type=style&index=0&id=632ece19&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632ece19"],['__file',"src/Web/scripts/components/StarfieldDebug.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "632ece19"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('632ece19', __exports__)) {
    api.reload('632ece19', __exports__)
  }
  
  module.hot.accept("./StarfieldDebug.vue?vue&type=template&id=632ece19&scoped=true", () => {
    api.rerender('632ece19', render)
  })

}


export default __exports__